import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Memaksa window scroll kembali ke kordinat X:0, Y:0 setiap kali URL (pathname) berubah
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}